/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
import React from 'react';
import { currencySymbol } from 'src/utils/currency';
import styled from 'styled-components';

const TableWrapper = styled.div`
  width: 60%;
  margin: auto;
  margin-top: 20px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`;

const TableHead = styled.thead`
  background: #666666;
`;

const HeaderCell = styled.th`
  color: #ffffff;
  font-size: 1.4rem;
  font-weight: 400;
  text-align: center;
  padding: 12px 16px;
`;

const Body = styled.tbody``;

const Row = styled.tr<{ $striped?: boolean }>`
  background: ${({ $striped }) => ($striped ? '#e7e7e7' : 'transparent')};
`;

const Cell = styled.td`
  font-size: 1.4rem;
  color: #666666;
  text-align: center;
  padding: 10px 2px;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const ReceiptCell = styled.td`
  text-align: center;
  padding: 12px 16px;
  vertical-align: middle;
`;

const ReceiptButton = styled.a`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background: #4948ac;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  text-decoration: none;

  &:hover {
    opacity: 0.92;
  }
`;

const ReceiptIcon = styled.span`
  font-size: 1.4rem;
  line-height: 1;
`;

const TotalSection = styled.div`
  margin-top: 6px;
`;

const TotalDivider = styled.div`
  width: 100%;
  border-top: 4px solid #000000;
`;

const TotalTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`;

const TotalRow = styled.tr``;

const TotalCell = styled.td`
  min-height: 90px;
  padding: 10px 2px;
  text-align: center;
  font-size: 1.4rem;
  font-weight: 600;
  color: #666666;
`;

interface ReceiptAttachment {
  id?: string;
  fileName: string;
  fileUrl?: string;
  attachmentUrl?: string;
}

interface ExpenseReceiptItem {
  id?: string;
  expenseDate: string;
  category: string;
  amount: string;
  miles: string;
  calculatedAmount: string;
  receipt: File | null;
  details: string;
  attachments?: ReceiptAttachment[] | null;
}

interface ExpenseReceiptTableProps {
  currency: string;
  expenses: ExpenseReceiptItem[];
}

const parseAmount = (amount?: string | number | null) => {
  if (amount === null || amount === undefined) return 0;
  const parsed = Number(amount);
  return Number.isNaN(parsed) ? 0 : parsed;
};

const getDetailsText = (item: ExpenseReceiptItem) => {
  return item.category === 'MILEAGE'
    ? `${item.miles || 0} miles${item.details ? ` - ${item.details}` : ''}`
    : item.details || '-';
};

const ExpenseReceiptTable: React.FC<ExpenseReceiptTableProps> = ({ expenses = [], currency = 'USD' }) => {
  const safeExpenses = Array.isArray(expenses) ? expenses : [];
  const total = safeExpenses.reduce((sum, item) => sum + parseAmount(item.calculatedAmount), 0);

  return (
    <TableWrapper>
      <StyledTable>
        <colgroup>
          <col style={{ width: '15%' }} />
          <col style={{ width: '15%' }} />
          <col style={{ width: '20%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '40%' }} />
        </colgroup>

        <TableHead>
          <tr>
            <HeaderCell>Date</HeaderCell>
            <HeaderCell>Category</HeaderCell>
            <HeaderCell>Amount</HeaderCell>
            <HeaderCell>Receipt</HeaderCell>
            <HeaderCell>Details</HeaderCell>
          </tr>
        </TableHead>

        <Body>
          {safeExpenses.map((item, index) => {
            const receiptUrl = item.attachments?.[0]?.attachmentUrl;
            const detailsText = getDetailsText(item);

            return (
              <Row key={item.id ?? index} $striped={index % 2 === 1}>
                <Cell title={item.expenseDate || '-'}>{item.expenseDate || '-'}</Cell>
                <Cell title={item.category || '-'}>{item.category || '-'}</Cell>
                <Cell title={`${currencySymbol(currency)}${parseAmount(item.calculatedAmount).toFixed(2)}`}>
                  {currencySymbol(currency)}
                  {parseAmount(item.calculatedAmount).toFixed(2)}
                </Cell>

                <ReceiptCell>
                  {receiptUrl ? (
                    <ReceiptButton
                      href={receiptUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Open receipt for ${item.category || 'expense'}`}
                    >
                      <ReceiptIcon>↗</ReceiptIcon>
                    </ReceiptButton>
                  ) : (
                    '-'
                  )}
                </ReceiptCell>

                <Cell title={detailsText}>{detailsText}</Cell>
              </Row>
            );
          })}
        </Body>
      </StyledTable>

      <TotalSection>
        <TotalDivider />

        <TotalTable>
          <colgroup>
            <col style={{ width: '15%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '40%' }} />
          </colgroup>

          <tbody>
            <TotalRow>
              <TotalCell />
              <TotalCell>Total</TotalCell>
              <TotalCell>
                {currencySymbol(currency)}
                {total.toFixed(2)}
              </TotalCell>
              <TotalCell />
              <TotalCell />
            </TotalRow>
          </tbody>
        </TotalTable>
      </TotalSection>
    </TableWrapper>
  );
};

export default ExpenseReceiptTable;
